import {
  resolveNotificationConfig as publicResolveNotificationConfig,
  upsertNotificationConfig as publicUpsertNotificationConfig,
  triggerNotification as publicTriggerNotification,
} from './events-notifications-v2-notification-config-notifications.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onNotificationConfigCreated as publicOnNotificationConfigCreated } from './events-notifications-v2-notification-config-notifications.public.js';
import { onNotificationConfigUpdated as publicOnNotificationConfigUpdated } from './events-notifications-v2-notification-config-notifications.public.js';

export const resolveNotificationConfig: MaybeContext<
  BuildRESTFunction<typeof publicResolveNotificationConfig> &
    typeof publicResolveNotificationConfig
> = /*#__PURE__*/ createRESTModule(publicResolveNotificationConfig);
export const upsertNotificationConfig: MaybeContext<
  BuildRESTFunction<typeof publicUpsertNotificationConfig> &
    typeof publicUpsertNotificationConfig
> = /*#__PURE__*/ createRESTModule(publicUpsertNotificationConfig);
export const triggerNotification: MaybeContext<
  BuildRESTFunction<typeof publicTriggerNotification> &
    typeof publicTriggerNotification
> = /*#__PURE__*/ createRESTModule(publicTriggerNotification);
/** */
export const onNotificationConfigCreated: BuildEventDefinition<
  typeof publicOnNotificationConfigCreated
> &
  typeof publicOnNotificationConfigCreated = createEventModule(
  publicOnNotificationConfigCreated
);
/** */
export const onNotificationConfigUpdated: BuildEventDefinition<
  typeof publicOnNotificationConfigUpdated
> &
  typeof publicOnNotificationConfigUpdated = createEventModule(
  publicOnNotificationConfigUpdated
);

export {
  EmailNotificationType,
  EmailNotificationReminderTime,
  LocationType,
  SubdivisionType,
  Status,
  EventStatus,
  WebhookIdentityType,
  PushNotificationType,
  OrderStatus,
  TaxType,
  FeeName,
  FeeType,
} from './events-notifications-v2-notification-config-notifications.universal.js';
export {
  NotificationConfig,
  EmailNotificationConfig,
  EmailTemplate,
  Link,
  ResolveNotificationConfigRequest,
  ResolveNotificationConfigResponse,
  UpsertNotificationConfigRequest,
  UpsertNotificationConfigResponse,
  ResolveEmailNotificationConfigRequest,
  ResolveEmailNotificationConfigResponse,
  EventCanceled,
  Empty,
  EventDeleted,
  EventCopied,
  Location,
  MapCoordinates,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  ScheduleConfig,
  Recurrences,
  Occurrence,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  TriggerNotificationRequest,
  TriggerNotificationRequestNotificationOneOf,
  TriggerNotificationRequestGuestsOneOf,
  RsvpGuest,
  OrderGuest,
  EventGuests,
  TicketGuest,
  TriggerNotificationResponse,
  OrderConfirmed,
  FormResponse,
  InputValue,
  FormattedAddress,
  CommonAddress,
  CommonAddressStreetOneOf,
  CommonStreetAddress,
  CommonAddressLocation,
  CommonSubdivision,
  StandardDetails,
  Ticket,
  CheckIn,
  Money,
  OnlineConferencingLogin,
  Invoice,
  Item,
  Discount,
  DiscountItem,
  DiscountItemDiscountOneOf,
  CouponDiscount,
  PaidPlanDiscount,
  PaidPlanDiscountDiscountOneOf,
  PercentDiscount,
  Tax,
  Fee,
  OrderEmailAdded,
  OrderPaid,
  TicketPdfResolved,
  TicketPdfResolveDelayed,
  OrderCanceled,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  NotificationConfigCreatedEnvelope,
  NotificationConfigUpdatedEnvelope,
  UpsertNotificationConfig,
  TriggerNotificationOptions,
  TriggerNotificationOptionsNotificationOneOf,
  TriggerNotificationOptionsGuestsOneOf,
} from './events-notifications-v2-notification-config-notifications.universal.js';
export {
  EmailNotificationTypeWithLiterals,
  EmailNotificationReminderTimeWithLiterals,
  LocationTypeWithLiterals,
  SubdivisionTypeWithLiterals,
  StatusWithLiterals,
  EventStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  PushNotificationTypeWithLiterals,
  OrderStatusWithLiterals,
  TaxTypeWithLiterals,
  FeeNameWithLiterals,
  FeeTypeWithLiterals,
} from './events-notifications-v2-notification-config-notifications.universal.js';
